import React, { useCallback, useContext } from 'react';
import Select from '../../../ui/Select';
import ToolbarContext from '../../../context/ToolbarContext';
import { FontOptions } from '../../../types';

const defaultFontFamilyOptions: FontOptions = [
  ['Arial', 'Arial'],
  ['Arial Black', 'Arial Black'],
  ['Comic Sans MS', 'Comic Sans MS'],
  ['Courier New', 'Courier New'],
  ['Georgia', 'Georgia'],
  ['Helvetica', 'Helvetica'],
  ['Impact', 'Impact'],
  ['Lucida Console', 'Lucida Console'],
  ['Lucida Sans Unicode', 'Lucida Sans Unicode'],
  ['Palatino', 'Palatino'],
  ['Tahoma', 'Tahoma'],
  ['Times New Roman', 'Times New Roman'],
  ['Trebuchet MS', 'Trebuchet MS'],
  ['Verdana', 'Verdana'],
];

interface IFontFamilyDropdown {
  fontOptions?: FontOptions;
}

const FontFamilyDropdown = ({
  fontOptions = defaultFontFamilyOptions,
}: IFontFamilyDropdown) => {
  const { fontFamily, applyStyleText } = useContext(ToolbarContext);

  const onFontFamilySelect = useCallback(
    (e) => {
      applyStyleText({ 'font-family': e.target.value });
    },
    [applyStyleText]
  );

  return (
    <>
      <Select
        className="toolbar-item font-family"
        onChange={onFontFamilySelect}
        options={fontOptions}
        value={fontFamily}
      />
      <i className="chevron-down inside" />
    </>
  );
};

export default FontFamilyDropdown;
